<template>
  <div class="fts-mobile-error">
    <div>
      <div class="mobile-error-title">{{errorTitle}}</div>
      <div class="mobile-error-description">{{errorMessage}}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    errorTitle: {
      type: String,
      default: 'Something went wrong'
    },
    errorMessage: {
      type: String,
      default: 'Page you trying to access is unavailable.'
    }
  }
}
</script>

<style lang="scss" scoped>
.fts-mobile-error {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  .mobile-error-title {
    font-weight: 500;
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
  .mobile-error-description {
    margin-top: 0.5rem;
    font-size: 0.875rem;
    line-height: 1.25rem;
    color: var(--fts-default);
    white-space: break-spaces;
  }
}
</style>